"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// matrix
var mat3_1 = require("./mat3");
exports.mat3 = mat3_1.default;
var vec2_1 = require("./vec2");
exports.vec2 = vec2_1.default;
var vec3_1 = require("./vec3");
exports.vec3 = vec3_1.default;
var transform_1 = require("./transform");
exports.transform = transform_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/matrix-util/lib/index.js
// module id = 78
// module chunks = 37